/** One row of the index payload.
 *
 * Positional, not an object: at ~19,000 rows the key names would be most of the
 * payload. The whole archive is ~2.3 MB of real text, ~1 MB gzipped, so it ships
 * in ONE request and lives in memory -- no pagination, no fetch during scroll.
 */
export type Row = [
  tsLocal: string,      // 'YYYY-MM-DD HH:MM:SS' in the zone you were actually in
  conv: string,
  sender: string,
  isMe: 0 | 1,
  kind: string,         // TEXT | MEDIA  (STATUS* is filtered server-side)
  body: string | null,
  bpm: number | null,   // null = no reading within [t-2min, t+15min]; render nothing
  mediaId: number | null,
  hashOrPeaks: string | null,  // blurhash (image/video) or JSON peaks (audio)
  w: number | null,
  h: number | null,
  durationS: number | null,
  // How far the reading was from the row, signed, negative = it came first.
  // Always null when bpm is null -- never 0, which rows.ts renders as 'now'.
  bpmLagS: number | null,
];

export const enum F { TsLocal, Conv, Sender, IsMe, Kind, Body, Bpm, MediaId, HashOrPeaks, W, H, DurationS, BpmLagS }

/** There is no media-kind field -- it is derived, and this is the rule.
 *  A NOTE is a voice note, and audio has no blurhash to fall back on; anything
 *  else with a duration is a video. Orphan files (3,809 of the full export's
 *  5,334, with no message at all) arrive as MEDIA or NOTE rows with an empty
 *  conv and sender, carrying their own tsLocal and bpm. */
export const mediaKind = (r: Row): "audio" | "video" | "image" | null =>
  r[F.MediaId] === null ? null
    : r[F.Kind] === "NOTE" ? "audio"
    : r[F.DurationS] !== null ? "video"
    : "image";

export const localMonth = (r: Row) => r[F.TsLocal].slice(0, 7);
export const localDate = (r: Row) => r[F.TsLocal].slice(0, 10);
export const localTime = (r: Row) => r[F.TsLocal].slice(11, 16);
